import React from "react";
import "./Skeleton.css";

type SkeletonProps = {
  width?: string;
  height?: string;
  borderRadius?: string;
};

export function Skeleton({
  width = "100%",
  height = "16px",
  borderRadius = "8px",
}: SkeletonProps) {
  return (
    <div
      className="ca-skeleton"
      style={{ width, height, borderRadius }}
    />
  );
}

export function SkeletonCard({ rows = 3 }: { rows?: number }) {
  return (
    <div className="ca-skeleton-card">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton
          key={i}
          width={i === 0 ? "40%" : i === rows - 1 ? "60%" : "80%"}
          height="14px"
        />
      ))}
    </div>
  );
}

export function SkeletonTable({
  rows = 5,
  cols = 4,
}: {
  rows?: number;
  cols?: number;
}) {
  return (
    <div className="ca-skeleton-table">
      <div className="ca-skeleton-table-header">
        {Array.from({ length: cols }).map((_, i) => (
          <Skeleton key={i} width="80px" height="12px" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="ca-skeleton-table-row">
          {Array.from({ length: cols }).map((_, c) => (
            <Skeleton
              key={c}
              width={c === 0 ? "120px" : "80px"}
              height="14px"
            />
          ))}
        </div>
      ))}
    </div>
  );
}
